import { TOKENGOOGLE_ERROR, TOKENGOOGLE_LOADING, TOKENGOOGLE_SUCCESS,TOKENGOOGLE_LOGOUT } from "../../ActionTypes";

import axiosGoogleToken from "../../../../global/helpers/axiosGoogleToken";

export const getAccessToken = (body) => (dispatch) => {
  dispatch({
    type: TOKENGOOGLE_LOADING,
  });

  axiosGoogleToken()
    .post(``,
      body
    )
    .then((res) => {
      dispatch({
        type: TOKENGOOGLE_SUCCESS,
        payload: res,
      });
    })
    .catch((err) => {
      let error = {
          status: err.toString()
      };
      dispatch({
        type: TOKENGOOGLE_ERROR,
        payload: error,
      });
    });
};


export const logoutAccessToken = () => (dispatch) => {
  dispatch({ type: TOKENGOOGLE_LOGOUT });  
};
